var map = {
	"./Center.png": "8b11",
	"./Combined Shape.png": "f6aa",
	"./DLP_LOGO_W.png": "ba87",
	"./DLP_LOGO_Y.png": "53655",
	"./LOGO_ GRAY.png": "11be",
	"./LOGO_ S.png": "2111",
	"./LOGO_XS.png": "6c6e",
	"./account_balance_wallet_opsz20.svg": "8605",
	"./admin_panel_settings_opsz24.svg": "7f4f",
	"./admin_panel_settings_opsz24B.svg": "c616",
	"./animation_640_lf1yjham.gif": "7848",
	"./campaign_black_18dp.svg": "4002",
	"./card0.png": "6672",
	"./card1.png": "ceb3",
	"./card2.png": "64e6",
	"./card5.png": "c3e62",
	"./contact_support_opsz20.svg": "fde6",
	"./contact_support_opsz20W.svg": "2cc9",
	"./delete_black_18dp.svg": "add7",
	"./dirori.png": "fb6d",
	"./dirori_box.png": "2975",
	"./dlp_main_mobile.png": "b4c3",
	"./dlp_main_pc.png": "a7ce",
	"./edit_black_18dp.svg": "abdd",
	"./enter_balance.png": "07bf",
	"./group_add_opsz20.svg": "c577",
	"./group_add_opsz20B.svg": "605b",
	"./group_add_opsz24.svg": "f8b3",
	"./group_add_opsz24B.svg": "65c8",
	"./group_remove_opsz20.svg": "c807",
	"./group_remove_opsz20B.svg": "3263",
	"./group_remove_opsz24.svg": "2de0",
	"./group_remove_opsz24B.svg": "3984",
	"./house20.svg": "7fc4",
	"./house20B.svg": "8d75",
	"./house24.svg": "64cf",
	"./house24B.svg": "a090",
	"./ing.png": "0118",
	"./kaikas-s.png": "660c",
	"./language_color_24dp.svg": "b3a2",
	"./language_white_24dp.svg": "f5bd",
	"./left.svg": "0182",
	"./local_activity_opsz20.svg": "2f09",
	"./local_activity_opsz20B.svg": "91a9",
	"./lock_clock_opsz20.svg": "564a",
	"./lock_clock_opsz20B.svg": "2762",
	"./lock_clock_opsz24.svg": "c845",
	"./lock_clock_opsz24B.svg": "3215",
	"./logout_black_24dp.svg": "fa06",
	"./lottery_mob_bg.png": "133c",
	"./lottery_mobi_enter.png": "8d96",
	"./lottery_mobi_info.png": "4b1b",
	"./lottery_pc_bg.png": "49df",
	"./lottery_pc_enter.png": "67bd",
	"./lottery_pc_info.png": "80d9",
	"./mema-s.png": "4e5a",
	"./menu_black_24dp.svg": "d709",
	"./metamask.png": "a510",
	"./mybalance.png": "02df",
	"./person_search_opsz20.svg": "c9b4",
	"./person_search_opsz20B.svg": "8a49",
	"./person_search_opsz24.svg": "1a29",
	"./person_search_opsz24B.svg": "3a9f",
	"./right.svg": "50d7",
	"./rock.png": "b36d",
	"./rock.svg": "9c9d",
	"./rock/botton0.png": "2259",
	"./rock/botton1.png": "cfc4",
	"./rock/botton2.png": "7d9d",
	"./rock/bottonSide.png": "254a",
	"./rock/derolee.png": "f41d",
	"./rock/gameBottom.png": "a8e1",
	"./rock/gameBottom2.png": "c429",
	"./rock/gameTop.png": "1472",
	"./rock/homeB.png": "957d",
	"./rock/homeS.png": "cefc",
	"./rock/jackpotR1.png": "adfe",
	"./rock/jackpotR22.png": "22d8",
	"./rock/jacpot.png": "92a0",
	"./rock/light.png": "8406",
	"./rock/lightW.png": "2a7a",
	"./rock/lose.png": "ffbb",
	"./rock/loseI.png": "6700",
	"./rock/money.png": "5259",
	"./rock/neon0.png": "1815",
	"./rock/neon1.png": "5765",
	"./rock/neon2.png": "6aa2",
	"./rock/star.png": "6ccb",
	"./rock/talk-b.png": "745e",
	"./rock/talk.png": "8945",
	"./rock/text.png": "5f9c",
	"./rock/text1-mobi.png": "e138",
	"./rock/text1.png": "5581",
	"./rock/win.png": "d672",
	"./rockB.png": "81fb",
	"./rockB.svg": "296d",
	"./stadia_controller_opsz20.svg": "f2f0",
	"./stadia_controller_opsz20B.svg": "0616",
	"./stadia_controller_opsz24.svg": "2232",
	"./stadia_controller_opsz24B.svg": "9bea",
	"./star.png": "ba5a",
	"./swap_horiz_opsz20.svg": "a703",
	"./swap_horiz_opsz24.svg": "3777",
	"./swap_horiz_opsz24B.svg": "8eae",
	"./swap_horizontal_circle_opsz20.svg": "53c1",
	"./swap_horizontal_circle_opsz20B.svg": "158e",
	"./swap_horizontal_circle_opsz24.svg": "428c",
	"./swap_horizontal_circle_opsz24B.svg": "3bec",
	"./symbol_multi_solid.png": "4bb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";